<form #loginForm="ngForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
        <label for="username" [innerHTML]="'auth.labels.form.username' | translate"></label>
        <input
                class="form-control"
                type="text"
                name="username"
                id="username"
                [(ngModel)]="loginInformation.username"
                placeholder="{{'auth.labels.form.username' | translate}}">
    </div>
    <div class="form-group">
        <label for="password" [innerHTML]="'auth.labels.form.password' | translate"></label>
        <input
                class="form-control"
                type="password"
                name="password"
                id="password"
                [(ngModel)]="loginInformation.password"
                placeholder="{{'auth.labels.form.password' | translate}}"
        >
        <div class="show-password"
             passwordToggle
             [elementTargetId]="'password'"
        >
            <span class="icon icon-ag-eye"></span>
        </div>
    </div>
    <span class="form-validation error" *ngIf="error.message">
        {{ error.message | translate }}
    </span>

    <div class="form-group">
        <button play-audio
                onEnterSound="btn_default_enter"
                onClickSound="btn_default_click"
                [disabled]="!loginForm.form.valid"
                class="btn-default float-right"
                type="submit"
        >
            <span [innerHTML]="'auth.buttons.login' | translate"></span>
        </button>
        <div class="servicelinks">
            <a routerLink="/password/forgot"
               class="btn-txt"
               [innerHTML]="'auth.buttons.password_forgotten' | translate"
            ></a>

            <a routerLink="/contact"
               class="btn-txt"
               [innerHTML]="'auth.buttons.contact' | translate"
            ></a>
        </div>
    </div>
</form>

